// fiat on rump services setup
export const ONRAMP_API_KEY = process.env.REACT_APP_ONRAMP_API_KEY;
export const TRANSAK_API_KEY = process.env.REACT_APP_TRANSAK_API_KEY;
export const ENABLE_NASH = process.env.REACT_APP_ENABLE_NASH === 'true';
